import React, { createContext, useState, useCallback } from 'react';

type Context = {
  setUserEmail: (email: string) => void;
  email: string;
};

export const UserAccountContext = createContext<Context>({} as Context);

export const UserAccountContextProvider = ({ children }: { children?: React.ReactNode }) => {
  const [email, setEmail] = useState<string>('');

  const setUserEmail = useCallback(userEmail => {
    setEmail(userEmail);
  }, []);

  return <UserAccountContext.Provider value={{ email, setUserEmail }}>{children}</UserAccountContext.Provider>;
};
